import { TextField as MUITextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField,
} from "components/request-document/components/Address";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalAssetsValue({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "countryConfig", []);

  useEffect(() => {
    const sum =
      parseFloat(
        formik.values.document.AssetsDepositValue !== ""
          ? formik.values.document.AssetsDepositValue
          : 0
      ) +
      parseFloat(
        formik.values.document.AssetsPrivateCommercialValue !== ""
          ? formik.values.document.AssetsPrivateCommercialValue
          : 0
      ) +
      parseFloat(
        formik.values.document.AssetsCloselyStocksValue !== ""
          ? formik.values.document.AssetsCloselyStocksValue
          : 0
      ) +
      parseFloat(
        formik.values.document.AssetsPubliclyTradedValue !== ""
          ? formik.values.document.AssetsPubliclyTradedValue
          : 0
      ) +
      parseFloat(
        formik.values.document.AssetsGoldAccountValue !== ""
          ? formik.values.document.AssetsGoldAccountValue
          : 0
      ) +
      parseFloat(
        formik.values.document.AssetsOtherValue !== ""
          ? formik.values.document.AssetsOtherValue
          : 0
      );
    formik.setFieldValue("document.TotalAssetsUSD", sum);
  }, [
    formik.values.document.AssetsDepositValue,
    formik.values.document.AssetsPrivateCommercialValue,
    formik.values.document.AssetsPrivateCommercialValue,
    formik.values.document.AssetsCloselyStocksValue,
    formik.values.document.AssetsPubliclyTradedValue,
    formik.values.document.AssetsGoldAccountValue,
    formik.values.document.AssetsOtherValue,
  ]);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Types of assets which the applicant has possessed
              </InputLabel>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Type of assets</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Country</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Value (USD)</InputLabel>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Deposit</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsDeposit`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsDeposit`}
                  value={get(formik.values, `document.AssetsDeposit`, "")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(`document.AssetsDeposit`, formik)}
                >
                  {getErrorMessage(`document.AssetsDeposit`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsDepositValue"
                value={formik.values.document.AssetsDepositValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsDepositValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsDepositValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                {" "}
                Private and commercial real estate and land
              </InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsPrivateCommercial`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsPrivateCommercial`}
                  value={get(
                    formik.values,
                    `document.AssetsPrivateCommercial`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(`document.AssetsPrivateCommercial`, formik)}
                >
                  {getErrorMessage(`document.AssetsPrivateCommercial`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsPrivateCommercialValue"
                value={formik.values.document.AssetsPrivateCommercialValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsPrivateCommercialValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsPrivateCommercialValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel> Closely held stocks</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsCloselyStocks`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsCloselyStocks`}
                  value={get(formik.values, `document.AssetsCloselyStocks`, "")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(`document.AssetsCloselyStocks`, formik)}
                >
                  {getErrorMessage(`document.AssetsCloselyStocks`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsCloselyStocksValue"
                value={formik.values.document.AssetsCloselyStocksValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsCloselyStocksValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsCloselyStocksValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Publicly traded stock and mutuak fund</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsPubliclyTraded`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsPubliclyTraded`}
                  value={get(
                    formik.values,
                    `document.AssetsPubliclyTraded`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(`document.AssetsPubliclyTraded`, formik)}
                >
                  {getErrorMessage(`document.AssetsPubliclyTraded`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsPubliclyTradedValue"
                value={formik.values.document.AssetsPubliclyTradedValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsPubliclyTradedValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsPubliclyTradedValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Gold in gold account</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsGoldAccount`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsGoldAccount`}
                  value={get(formik.values, `document.AssetsGoldAccount`, "")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(`document.AssetsGoldAccount`, formik)}
                >
                  {getErrorMessage(`document.AssetsGoldAccount`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsGoldAccountValue"
                value={formik.values.document.AssetsGoldAccountValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsGoldAccountValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsGoldAccountValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Other </InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(`document.AssetsOther`, formik)}
              >
                <InputLabel>Select Country</InputLabel>
                <Select
                  label="Select nationality"
                  name={`document.AssetsOther`}
                  value={get(formik.values, `document.AssetsOther`, "")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.countryId}
                      key={nationality.countryId}
                    >
                      {nationality.countryName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error={isError(`document.AssetsOther`, formik)}>
                  {getErrorMessage(`document.AssetsOther`, formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.AssetsOtherValue"
                value={formik.values.document.AssetsOtherValue}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.AssetsOtherValue", formik)}
                helperText={getErrorMessage(
                  "document.AssetsOtherValue",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Total assets value (USD)</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.TotalAssetsUSD"
                value={formik.values.document.TotalAssetsUSD}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                inputProps={{ readOnly: true }}
                error={isError("document.TotalAssetsUSD", formik)}
                helperText={getErrorMessage("document.TotalAssetsUSD", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <StyledTableCell colSpan={7}>
        <Typography>
          Note : The evidences of ownership of the assets above must be
          presented with the application. Only assessable assets are acceptable.
        </Typography>
      </StyledTableCell>
    </>
  );
}
